import { BaseService } from "./../base";
export class EthnicgroupService extends BaseService {
  static get entity() {
    return "ethnic_group";
  }
  static get name() {
    return "ethnic_groups";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }
}
